function setupSourceSticky(){
 document.querySelectorAll('[data-source-sticky]').forEach(bar=>{
 if(bar.dataset.ready)return;
 const offers=bar.closest('.shopify-section')?.querySelector('.essentae-source-offers');
 if(!offers)return;bar.dataset.ready='true';
 const controller=new AbortController();let frame=0;
 const update=()=>{frame=0;if(!bar.isConnected){controller.abort();observer.disconnect();return;}
 const rect=offers.getBoundingClientRect();
 bar.hidden=!(rect.bottom<0);};
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
 bar.querySelector('button').addEventListener('click',()=>{
 const header=document.querySelector('header');const offset=(header?.getBoundingClientRect().height||0)+20;
 window.scrollTo({top:Math.max(0,offers.getBoundingClientRect().top+scrollY-offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 offers.setAttribute('tabindex','-1');offers.focus({preventScroll:true});
 });
 window.addEventListener('scroll',schedule,{passive:true,signal:controller.signal});window.addEventListener('resize',schedule,{signal:controller.signal});
 const observer=new ResizeObserver(schedule);observer.observe(offers);update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupSourceSticky,{once:true});else setupSourceSticky();
document.addEventListener('shopify:section:load',setupSourceSticky);
